import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * MentalHealth icon
 *
 * @category Medical
 */
const MentalHealth = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M8.163 10.71c-.2 1.58-1.23 2.55-1.99 3.92-1.01 1.37-1.46 2.7.21 3.64.4.27.91.53 1.01.99.11.5.05 1.35.07 1.93-.19 3.11.79 3.34 3.53 3.27 1.24-.05 1.42.53 1.38 1.83-.03 1.26.08 2.35 1.3 2.74l.1.03c1.43.07 6.15-.03 8.1-.03 2.3-.28 1.52-2.43 1.13-4.24-.18-.9-.33-1.47-.28-1.8.19-.77.74-1.49 1.1-2.25 1.17-2.15 2.21-3.88 2.61-6.23 2.37-12.62-15.59-16.2-18.27-3.8m17.36 3.63c-.17 1-.9 2.06-1.87 2.34-.82.23-1.83.18-2.47.03-1.85-.35-.84-1.26-.06-2.13.75-.56 1.95-.23 2.55-1.11.51-.58.53-1.51.13-2.17-.28-.53-.85-.83-1.09-1.37-.35-1.76-1.14-3.84-3.23-3.65-.96-.07-1.74.79-2.65.72-.45-.1-.86-.45-1.3-.6-1.07-.44-2.7-.22-3.36.79-.64.87-.46 2.27.5 2.79 1.19.68 2.63-.02 3.59-.8.96-.92 1.67.75 1.96 1.51.12.78-.59 1.45-.65 2.23-.51 2.49 1.75 4.91 4.24 4.87l.32-.03c1.06-.26 2.02-.4 2.87-.76l.07-.29c-.53 1.15-1.9 2.67-2.5 3.82-.98 1.83-1.28 2.08-1.02 3.36.16.76.62 1.63.79 2.41.33 1.3.18 1.7-.55 1.74-1.02-.04-4.53.11-6.78.05-.89-.03-1.6-.75-1.62-1.64-.03-1.09.06-2.37-.94-2.75-.68-.58-3.76.34-3.91-.98-.25-1.38-.08-3.01-.85-4.23-.5-.7-1.41-1.23-1.39-1.8.17-1.05 1.64-2.77 2.19-3.85.42-.61.52-1.13.65-1.84.59-3.95 4.14-6.99 8.14-7.01h.19c5.77.08 8.93 5.31 8.07 10.37zm-5.14-4.37c-.36.03-.8.33-1.1.36-.32-.43-.92-1.4-1.26-1.96a.54.54 0 0 1 .19-.73c1.8-1.08 3.28 0 3.29 2.2-.22.12-.79 0-1.13.12zm1.18 1.14c-.04.52-.17.85-.44 1.37-.07.15-.15.29-.23.43-.4-.29-1.1-1.2-1.21-1.43.55-.36 1.25-.49 1.88-.37m-2.62.93c.08.14.16.29.24.43.26.43.65.93 1.18 1.29-.38.58-.82 1.12-1.29 1.62-.12-.18-.23-.36-.32-.56-.39-.9-.3-1.98.18-2.78zm2.89 1.23c.06-.11.12-.23.18-.34.25-.49.42-1.01.5-1.57.35.3.61.78.49 1.21-.12.46-.66.71-1.17.71zm-5.23-5.34c-.46.4-1.23.79-1.72 1.07s-1.22.48-1.67.14c-.17-.13-.28-.34-.31-.6-.03-.31.06-.64.25-.86.28-.33.76-.52 1.27-.52q.24 0 .48.06c.45.11 1.25.33 1.7.71"
        />
      </svg>
    );
  }
);

MentalHealth.displayName = 'MentalHealth';

export { MentalHealth };
